module.exports = __webpack_public_path__ + "a14a657e9ae50da4e27a055daed4ef3c.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_xlarge_x1/public/modules/image/sample.png
// module id = 336
// module chunks = 0